import React from 'react';
import AtlasV2DorisSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisSplineChart';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import { useProductEntity } from 'src/utils/Hooks/reduxSelectors';

const AtlasSalesMarketShareProductSplineChart = () => {
  const { productEntity } = useProductEntity();
  return (
    <AtlasV2DorisSplineChart
      queryKey="MarketShareProductSplineChart"
      title="Market Share of Retail Sales"
      methodName="sales/GetSalesMetrics"
      metricTypeDisplay={METRICTYPE.PERCENT}
      metricType="retailSales"
      showMarketShare={true}
      marketShareRequestBuilder={(params) => {
        return {
          ...params,
          stacklineSkus: [],
          categoryIds: productEntity?.categoryIds
        };
      }}
    />
  );
};

export default AtlasSalesMarketShareProductSplineChart;
